import { config } from "../../../../cookist/it/lib/config/production.js";
import { CookistModuleLoader } from "../../../../cookist/it/pa/modularization/CookistModuleLoader.js";

const al = new CookistModuleLoader(window, config);
const gui = al.getGui();